import { render, staticRenderFns } from "./app-task-progress.vue?vue&type=template&id=230c877d"
import script from "./app-task-progress.vue?vue&type=script&lang=ts"
export * from "./app-task-progress.vue?vue&type=script&lang=ts"
import style0 from "./app-task-progress.vue?vue&type=style&index=0&id=230c877d&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/volateq-web-app/volateq-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('230c877d')) {
      api.createRecord('230c877d', component.options)
    } else {
      api.reload('230c877d', component.options)
    }
    module.hot.accept("./app-task-progress.vue?vue&type=template&id=230c877d", function () {
      api.rerender('230c877d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/app-task-progress/app-task-progress.vue"
export default component.exports